<script setup>
import { computed } from 'vue'

import DashboardStatsUserCard from '@/Components/Dashboard/DashboardStatsUserCard'
import OrganisationMembership from '@/Components/Dashboard/Widgets/OrganisationMembership'
import OrganisationNumUsers from '@/Components/Dashboard/Widgets/OrganisationNumUsers'
import OrganisationNextInvoiceDue from '@/Components/Dashboard/Widgets/OrganisationNextInvoiceDue'
import OrganisationUpcomingEvent from '@/Components/Dashboard/Widgets/OrganisationUpcomingEvent'

import CalendarIcon from '@/icons/CalendarIcon'

import { formatDate } from '@/Mixins/FormatsDates'

import { useAuthStore } from '@/Stores/auth'
const auth = useAuthStore()

const props = defineProps({
	organisation: {
		type: Object,
		default: null,
	}
})

// if we haven't been passed an organisation, grab the active_organisation instead
const activeOrganisation = computed(() => {
	return props.organisation ?? auth.active_organisation
})
</script>

<template>
	<div v-if="activeOrganisation" class="grid gap-4 md:gap-2 lg:gap-4 grid-cols-1 md:grid-cols-2 w-[100%]">
		<OrganisationMembership :organisation="activeOrganisation" />
		<OrganisationNextInvoiceDue :organisation="activeOrganisation" v-if="auth.can('view_invoices')" />
		<OrganisationNumUsers :organisation="activeOrganisation" v-if="auth.can('manage_contacts')" />
		<OrganisationUpcomingEvent :organisation="activeOrganisation" />
	</div>
</template>